// extracted by mini-css-extract-plugin
export default {"title-section":"evtS","titleSection":"evtS","tabs":"I4nZ"};